import type { TypedThunk } from 'src/store/types'

import { getJackpots } from './api/getJackpots'
import { actions } from './slice'

export const { setJackpotsData } = actions

export const fetchJackpots =
  (apiUrl: string): TypedThunk =>
  async (dispatch, _getState, { fetch }) => {
    const jackpots = await getJackpots(apiUrl, fetch)

    dispatch(setJackpotsData(jackpots))
  }
